import React from "react";
import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import Premium from "./Premium";
import PremiumAdmin from "./PremiumAdmin";
import OrderDetail from "./OrderDetail";
import DocumentPreview from "./DocumentPreview";
import { PreviewKind } from "./constants";
import PremiumLayout from "./components/PremiumLayout";
import { legacyPremiumPath, premiumPaths } from "./navigation";

export function LegacyPremiumRedirect() {
  const location = useLocation();
  return <Navigate to={legacyPremiumPath(location)} replace />;
}

/** Trasy odpowiadają ekranom; odświeżenie i historia przeglądarki zachowują firmę i zakładkę. */
export default function PremiumRoutes() {
  return (
    <Routes>
      <Route index element={<Premium />} />
      <Route
        path="companies/:companyId/orders"
        element={<Premium section="orders" />}
      />
      <Route
        path="companies/:companyId/orders/new"
        element={<Premium section="new" />}
      />
      <Route
        path="companies/:companyId/dictionaries"
        element={<Premium section="dictionaries" />}
      />
      <Route path="orders/:orderId" element={<OrderDetail />} />
      <Route
        path="orders/:orderId/documents"
        element={<OrderDetail step={1} />}
      />
      <Route path="orders/:orderId/issue" element={<OrderDetail step={4} />} />
      {[false, true].flatMap((admin) => {
        const Page = admin ? PremiumAdmin : Premium;
        const prefix = `${admin ? "admin/" : ""}companies/:companyId/dictionaries/:dictionaryKind`;
        return [
          <Route
            key={prefix}
            path={prefix}
            element={<Page section="dictionaries" />}
          />,
          <Route
            key={`${prefix}/new`}
            path={`${prefix}/new`}
            element={<Page section="dictionaries" action="new" />}
          />,
          <Route
            key={`${prefix}/edit`}
            path={`${prefix}/edit`}
            element={<Page section="dictionaries" action="edit" />}
          />,
        ];
      })}
      <Route
        path="orders/:orderId/preview"
        element={<DocumentPreview kind={PreviewKind.DRAFT} />}
      />
      <Route
        path="orders/:orderId/documents/:documentId"
        element={<DocumentPreview kind={PreviewKind.SOURCE} />}
      />
      <Route
        path="orders/:orderId/certificate"
        element={<DocumentPreview kind={PreviewKind.CERTIFICATE} />}
      />
      <Route path="admin/companies" element={<PremiumAdmin />} />
      <Route
        path="admin/companies/new"
        element={<PremiumAdmin section="new" />}
      />
      <Route
        path="admin/companies/:companyId/settings"
        element={<PremiumAdmin section="settings" />}
      />
      <Route
        path="admin/companies/:companyId/members"
        element={<PremiumAdmin section="members" />}
      />
      <Route
        path="admin/companies/:companyId/members/new"
        element={<PremiumAdmin section="members" action="new" />}
      />
      <Route
        path="admin/companies/:companyId/members/:memberId/edit"
        element={<PremiumAdmin section="members" action="edit" />}
      />
      <Route
        path="admin/companies/:companyId/dictionaries"
        element={<PremiumAdmin section="dictionaries" />}
      />
      {["admin", "history", "configuration", "configuration/test"].map(
        (path) => (
          <Route key={path} path={path} element={<LegacyPremiumRedirect />} />
        ),
      )}
      <Route
        path="*"
        element={
          <PremiumLayout title="Nie znaleziono strony">
            <div className="card premium-panel">
              <p>Ten adres Premium nie prowadzi do dostępnego widoku.</p>
              <Link to={premiumPaths.home}>Wróć do konta Premium</Link>
            </div>
          </PremiumLayout>
        }
      />
    </Routes>
  );
}
